import React, { useEffect, useState, useCallback } from "react";
import DataTable from "react-data-table-component";
import * as axiosInstance from '../utils/axiosinstace';import { useTranslation } from 'react-i18next';


const DeviceConnections = () => {
  const { t } = useTranslation(['common', 'analytics', 'device', 'farm', 'batch', 'user']);
    const [data, setData] = useState([]);
    const [lastMessage, setLastMessage] = useState(null); // For debugging: holds the last received message

    const columns = [
        {
          name: t('common:entity.farmer'),
          selector: "farmer",
          sortable: true,
           minWidth: '200px'
        },
        {
          name: t('common:fields.farmName'),
          selector: "farmName",
          sortable: true,
          
        },
        {
          name: t('common:entity.batch'),
          selector: "batchName",
          sortable: true,
         
        },
        {
            name: t('device:list.imeiNumber'),
            selector: "imeiNumber",
            sortable: true,
            minWidth: '170px'
        },
        {
            name: t('farm:list.mobileNetwork'),
            selector: "network",
            sortable: true,
            minWidth: '170px'
        },
        {
            name: t('device:list.addedDate'),
            selector: "createdDate",
            sortable: true,
            minWidth: '170px'
        },
        {
            name: "status",
            selector: "connectionStatus",
            sortable: true,
            
            cell: row => <div style={{
                ...statusStyle,
                backgroundColor: row.connectionStatus === 'Connected' ? '#00933b' :
                                row.connectionStatus === 'Connection Lost/Device is in off-state' ? '#a60505' : '#444'
            }}>{row.connectionStatus}</div>
        },
        {
            name: t('device:list.signalStrength'),
            selector: "signalStrength",
            sortable: true,
            right: true,
        },
        {
            name: t('device:list.lastPingReceivedAt'),
            selector: "lastUpdated",
            sortable: true,
            left: true,
            width: '200px'
        }
      ];
      const statusStyle = {
            padding: '5px',
            borderRadius: '15px',
            color: 'white',
        };

        const fetchDevices = useCallback(async () => {
            try {
                const response = await axiosInstance.getConnectionsList();
        
                const transformDevices = (devices) => 
                    devices.map(device => {
                        if (device.connectionStatus) {
                            // Split connectionStatus and extract values
                            const [connectionStatus, signalStrength, lastUpdated] = device.connectionStatus.split(',');
                            return {
                                ...device,
                                connectionStatus, // Extracted connection status
                                signalStrength: signalStrength ? `${signalStrength} dBm` : null, // Signal strength with "dBm" appended
                                lastUpdated: lastUpdated || '', // Extracted last updated date or fallback to empty string
                            };
                        } else {
                            return {
                                ...device,
                                connectionStatus: 'Disconnected', // Default connection status
                                signalStrength: null, // Default signal strength
                                lastUpdated: '', // Default last updated value
                            };
                        }
                    });
        
                const transformedData = transformDevices(response.list);
        
                setData(transformedData);
                setDisplayData(transformedData);
            } catch (err) {
                console.error('Error fetching devices:', err);
            }
        }, []);
        

    useEffect(() => {
        fetchDevices();
        // alert(JSON.stringify(data))
    }, [fetchDevices]);

    // useEffect(() => {
    //     const ws = new WebSocket('wss://ipoultry.digiterrain.live/ws/');

    //     ws.onopen = () => {
    //         console.log('connected');
    //     };

    //     ws.onerror = (error) => {
    //         console.error("WebSocket error observed:", error);
    //     };

    //     ws.onmessage = evt => {
    //         try {
    //             // Parse the message
    //             const message = JSON.parse(evt.data);
    //             console.log("Received message:", message);

    //             // Update lastMessage state for debugging purposes
    //             setLastMessage(message);

    //             // Extract the deviceID and status
    //             const { deviceID, status, date } = message;
    //             const [connectionStatus, signalStrength] = status.split(',');

    //             // Update the state with the new status
    //             setData(prevData => {
    //                 const newData = prevData.map(device => {
    //                     if (device.imeiNumber === deviceID) {
    //                         return {
    //                             ...device,
    //                             connectionStatus,
    //                             signalStrength:`${signalStrength} dBm`,
    //                             lastUpdated: date, // Updating the last updated date
    //                         };
    //                     }
    //                     return device;
    //                 });
    //                 return newData;
    //             });

    //         } catch (error) {
    //             console.error("Error parsing message:", error);
    //         }
    //     };

    //     ws.onclose = () => {
    //         console.log('disconnected');
    //     };

    //     // Clean up
    //     return () => {
    //         ws.close();
    //     };
    // }, []);
    const [searchTerm, setSearchTerm] = useState('');
    const [displayData, setDisplayData] = useState([]);

    useEffect(() => {
        if (searchTerm !== '' && searchTerm.length > 2) {
            const filteredData = data.filter(item => {
                const farmName = item.farmName || "";
                const batchName  = item.batchName || "";
                const signalStrength = item.signalStrength || "";
                const imei = item.imeiNumber || "";
                const farmer = item.farmer || "";
                const network = item.network || "";
                return farmer.toLowerCase().includes(searchTerm.toLowerCase()) || farmName.toLowerCase().includes(searchTerm.toLowerCase()) || 
                batchName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                imei.includes(searchTerm) ||
                network.toLowerCase().includes(searchTerm.toLowerCase()) ||
                signalStrength.toLowerCase().includes(searchTerm.toLowerCase());
            });
            setDisplayData(filteredData);
        } else {
            setDisplayData(data);
        }
    }, [searchTerm, data]);
    return (
        <div className="devicesConnections">
            <div className="card">
                <div className="card-body">
                <div className="row">
                        <div className="col-md-6">
                            <form>
                                <div class="input-group">
                                    <input type="search" className="form-control form-control-sm" 
                                    placeholder={t('device:list.connSearch')} 
                                    //value={searchTerm}
                                    onKeyUp={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <div class="input-group-append">
                                        <div type="submit" className="btn btn-sm btn-default">
                                            <i class="fa fa-search"></i>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <br></br>
                        {/* <div className="col-md-8">
                            <ul class="controls">
                                <li><button onClick={()=>setShowAddPopup(true)}  type="button" class="btn btn-block btn-outline-success btn-sm">
                                    Add Device</button></li>
                                <li><button onClick={()=>deactivateDevice()} type="button" class="btn btn-block btn-outline-danger btn-sm">{t('device:list.deactivate')}</button></li>
                            </ul>
                        </div> */}
                    </div>
                    <br></br>
                    <DataTable
                        key={Math.random()}
                        columns={columns}
                        data={displayData}
                        defaultSortField="Added Date"
                        pagination
                        dense
                        selectableRowsHighlight={true}
                        compact
                        highlightOnHover={true}
                        striped
                    />
                </div>
            </div>
        </div>
    );
}

export default DeviceConnections;
